import { App, inject } from 'vue'

import { DefaultAPIInstance } from '@/api/instance'
import { useAuthStore } from '@/store/auth-store'
import { storeToRefs } from 'pinia'
import { locale } from '@/plugins/i18n'

export const useApi = () => {
  const authStore = useAuthStore()
  const { token } = storeToRefs(authStore)

  return DefaultAPIInstance(
    {
      headers: {
        Authorization: `Bearer ${token.value}`,
        'Accept-Language': locale.value,
      },
    },
    (status: number) => authStore.clearAuthData(),
  )
}
